import React, { useCallback, useState } from 'react';
import { useApolloClient, useMutation } from '@apollo/client';
import { useTeamInfo } from '../../team-id-context';
import { useDealId } from '../../deal-id-context';
import ArchiveModal from './archiveModal';
import { useDealRoles } from '../../shared/hooks/useDealRoles/useDealRoles';
import StatusDropdown, { DealStatus, DropdownStatusesEnum } from './components/statusDropdown/statusDropdown';
import { usePermissions } from '../../auth';
import { useDocumentTeamPermissions } from '../document-wizard/shared/hooks/use-document-team-permissions/use-document-team-permissions';
import { useDeal } from '../../contexts/DealContext';
import { mutations } from '../../api';
import { getDealById } from '../../api/queries';
import styles from './styles.module.scss';

const LOADING_SPINNER_HEIGHT = 35;
const LOADING_SPINNER_WIDTH = 102;

interface ControlsProps {
  teamId: string;
  dealId: string;
  controlClassName?: string;
}

const Controls = ({ teamId, dealId, controlClassName }: ControlsProps) => {
  const teamIdLookup = useTeamInfo().teamId;
  const dealIdLookup = useDealId();
  const { currentDeal } = useDeal();
  const { isAdmin } = usePermissions();
  const selectedTeamId: string = teamId || teamIdLookup;
  const selectedDealId: string = dealId || dealIdLookup;
  const { isCreator, isDealRolesLoading } = useDealRoles(selectedDealId);

  const [isArchiveModalOpen, setArchiveModalOpen] = useState(false);
  const apolloClient = useApolloClient();
  const [updateDealDetails] = useMutation(mutations.updateDealDetails, {
    refetchQueries: [
      {
        query: getDealById,
        variables: {
          dealId,
        },
      },
    ],
  });
  const { hasEditPermission } = useDocumentTeamPermissions({ teamId: selectedTeamId, apolloClient });
  const handleUpdateDealStatus = useCallback(
    async (dealId: string, newStatus: DealStatus) => {
      await updateDealDetails({
        variables: {
          dealId,
          dealDetails: {
            status: newStatus,
          },
        },
      });
    },
    [updateDealDetails]
  );

  // No spinner - let controls render immediately
  // They will just be disabled/hidden while roles are loading
  return (
    <>
      <div className="d-flex">
        {(isAdmin || hasEditPermission) && isCreator ? (
          <StatusDropdown
            /*
             // @ts-ignore */
            id={styles['status-dropdown']}
            className={'w-100'}
            wrapperClassName={controlClassName}
            currentStatus={currentDeal?.status as DealStatus}
            onStatusChange={(newStatus: DealStatus) => {
              handleUpdateDealStatus(dealId!, newStatus);
            }}
          />
        ) : (
          <span className={styles.headerDealStatus}>
            {DropdownStatusesEnum[currentDeal?.status as DealStatus]}
          </span>
        )}
      </div>

      <ArchiveModal
        isOpen={isArchiveModalOpen}
        onClose={() => setArchiveModalOpen(false)}
        onUpdateArchived={() => {}}
      />
    </>
  );
};

export default Controls;
